if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.slideContainer = this.querySelector(
        "[data-swiper]:not([data-swiper-thumbs])"
      );
      this.slides = this.querySelectorAll("[data-swiper-slide]");
      this.sliderOptions = this.applyDefaultOptions(
        this.getSliderOptions(this.dataset.swiperOptions)
      );
      this.activeIndex = 0;
      this.initialized = false;
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector("[data-swiper-thumbs]");
      }
    }

    connectedCallback() {
      setTimeout(() => {
        if (this.dataset.customEvent) {
          this.attachCustomListeners(this.dataset.customEvent);
        }
        if (this.slideContainer && this.slides.length > 0) {
          this.initializeSwiper()
          window.addEventListener("resize", this.handleResize.bind(this));
          this.addEventListener("go-to-slide", this.goToSlide.bind(this));
          this.addEventListener("update-slides", this.updateSlides.bind(this));
        } else {
          console.warn("SwiperSlider - Slider or Slides Not Found");
        }
      });
    }

    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "swiper_event":
          document.addEventListener(
            "swiper_event",
            this.updateSlides.bind(this)
          );
          break;
      }
    }

    updateSlides(evt) {
      this.slider.appendSlide(evt.detail.slides);
      this.slider.thumbs.swiper.appendSlide(evt.detail.thumbs);
      this.goToSlide(evt);
      if(this.slider.thumbs) {
        this.slider.thumbs.swiper.update();
      }
      this.slider.update();
    }

    goToSlide(evt) {
      let index = evt.detail.index;
      if (!index && evt.detail.position) {
        const elm = this.querySelector(
          "[data-position='" + evt.detail.position + "']"
        );
        index = [...elm.parentNode.children].indexOf(elm);
      }
      if (index != 0 && !index) return;
      this.slider.slideTo(index);
    }

    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = true;
      }
      if(options.speed === undefined) {
        options.speed = 400;
      }      
      return options;
    }

    getSliderOptions(data) {
      try {
        return JSON.parse(data);
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        if (this.thumbnails) {          
          this.setThumbnails();
        }
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        this.initializeSliderEventListeners();
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }

    setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = this.getSliderOptions(
        this.thumbnails.dataset.swiperOptions
      );
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
      this.sliderOptions.on = {
        slideChange: function () {
          const activeIndex = this.activeIndex;
          this.thumbs.swiper.slideTo(activeIndex);
        },
      };
    }

    initializeSliderEventListeners() {}
  }
  customElements.define("swiper-slider", SwiperSlider);
}
